import { render } from "./JsonEditor.vue?vue&type=template&id=1a0e4a2b&scoped=true"
import script from "./JsonEditor.vue?vue&type=script&lang=js"
export * from "./JsonEditor.vue?vue&type=script&lang=js"

import "./JsonEditor.vue?vue&type=style&index=0&id=1a0e4a2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0e4a2b"]])

export default __exports__